
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface BlogFiltersProps {
  categories: string[];
  tags: string[];
  selectedCategory: string | null;
  selectedTag: string | null;
  onCategoryClick: (category: string) => void;
  onTagClick: (tag: string) => void;
}

const BlogFilters: React.FC<BlogFiltersProps> = ({ 
  categories, 
  tags, 
  selectedCategory, 
  selectedTag, 
  onCategoryClick, 
  onTagClick 
}) => {
  return (
    <div className="sticky top-24 space-y-8">
      {/* Categories section */}
      <div>
        <h3 className="font-semibold mb-3 text-lg">Categories</h3>
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <Badge 
              key={category}
              variant={selectedCategory === category ? "default" : "outline"}
              className="cursor-pointer"
              onClick={() => onCategoryClick(category)}
            >
              {category}
            </Badge>
          ))}
        </div>
      </div>
      
      {/* Tags section */}
      <div>
        <h3 className="font-semibold mb-3 text-lg">Popular Tags</h3>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <Badge 
              key={tag}
              variant={selectedTag === tag ? "default" : "outline"}
              className="cursor-pointer"
              onClick={() => onTagClick(tag)}
            >
              {tag}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogFilters;
